import { colors } from 'config/theme';

export const pieColors = [
  colors.uswds.primary.main,
  colors.uswds.base.light,
  colors.success.main,
  colors.uswds.basic.orange,
];
